export default "__VITE_ASSET__BpgqIkAS__"